import { getCurrencySymbol } from '../functions/currency'
import isPopulated from '../functions/isPopulated'

export const formatCurrency = (currency, style) => {
  if (!isPopulated(currency)) {
    return ''
  }

  switch (style) {
    case 1:
      return currency.concat(' (', getCurrencySymbol(currency), ')')
    default:
      return currency
  }
}
